<!-- 财务统计首页 -->
<template>
  <div>
    <div><el-button icon="el-icon-refresh" size="mini" circle @click="loadAll"></el-button></div>
    <el-tabs v-model="activeTab" class="margin-top-sm">
      <el-tab-pane label="总览" name="overview">
        <FinanceStatisticalOverview :data="overviewData" @jump="jumpTo" />
      </el-tab-pane>
      <el-tab-pane label="业务对账" name="reconcile">
        <FinanceBizReconcilePanel :data="reconcileData" @jump="jumpTo" @refresh="loadReconcileData" />
      </el-tab-pane>
      <el-tab-pane label="账户流水对账" name="wealthWay">
        <FinanceWealthWayDailyPanel :data="wealthWayData" @jump="jumpTo" @refresh="loadWealthWayData" />
      </el-tab-pane>
      <el-tab-pane label="截止日汇总" name="asOf">
        <FinanceAsOfStatPanel />
      </el-tab-pane>
      <el-tab-pane label="平台PV账户" name="platformPv">
        <FinancePlatformPvPanel :data="reconcileData" @jump="jumpTo" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { QueryFinanceIndexData, QueryFinanceBizReconcileIndexData, QueryFinanceWealthWayDailyIndexData } from '@/api'
import FinanceStatisticalOverview from './components/FinanceStatisticalOverview.vue'
import FinanceBizReconcilePanel from './components/FinanceBizReconcilePanel.vue'
import FinanceWealthWayDailyPanel from './components/FinanceWealthWayDailyPanel.vue'
import FinanceAsOfStatPanel from './components/FinanceAsOfStatPanel.vue'
import FinancePlatformPvPanel from './components/FinancePlatformPvPanel.vue'

export default {
  name: 'financeStatisticalIndex',
  components: { FinanceStatisticalOverview, FinanceBizReconcilePanel, FinanceWealthWayDailyPanel, FinanceAsOfStatPanel, FinancePlatformPvPanel },
  data() {
    return {
      activeTab: 'overview',
      overviewData: {
        dailySalesStatMap: { today: {}, yesterday: {} },
        mengBeanSummaryMap: { today: {}, yesterday: {} },
        platformPvSummaryMap: { today: {}, yesterday: {} },
        energyContributionStatMap: { today: {}, yesterday: {} },
        withdrawMerchantBalanceStatMap: { today: {}, yesterday: {} },
      },
      reconcileData: {
        allocateRechargeMap: { today: {}, yesterday: {} },
        specialPriceMap: { today: {}, yesterday: {} },
        distributionMap: { today: {}, yesterday: {} },
        bizPvReconcileMap: { today: {}, yesterday: {} },
        platformPvSummaryMap: { today: {}, yesterday: {} },
      },
      wealthWayData: {
        mungBeanBalanceMap: { today: {}, yesterday: {} },
        pointsBalanceMap: { today: {}, yesterday: {} },
        mungBeanCategoryMap: { today: [], yesterday: [] },
        pointsCategoryMap: { today: [], yesterday: [] },
        bizPvReconcileMap: { today: {}, yesterday: {} },
      },
    }
  },
  created() {
    this.loadAll()
  },
  methods: {
    jumpTo(url) {
      const idx = url.indexOf('?')
      if (idx < 0) {
        this.$router.push(url)
        return
      }
      const path = url.substring(0, idx)
      const query = {}
      url.substring(idx + 1).split('&').forEach(pair => {
        const parts = pair.split('=')
        const k = parts[0]
        const v = parts[1]
        if (k) query[k] = v || ''
      })
      this.$router.push({ path, query })
    },
    loadAll() {
      QueryFinanceIndexData({}).then(res => {
        if (res) this.overviewData = res
      })
      this.loadReconcileData()
      this.loadWealthWayData()
    },
    loadReconcileData() {
      QueryFinanceBizReconcileIndexData({}).then(res => {
        if (res) this.reconcileData = res
      })
    },
    loadWealthWayData() {
      QueryFinanceWealthWayDailyIndexData({}).then(res => {
        if (res) this.wealthWayData = res
      })
    },
  },
}
</script>
